import React from "react";
import BgImg from "../../../images/case-studies/stock/ship.webp";
import { Col, Container, Row } from "react-bootstrap";

function Platformstock() {
  return (
    <section
      className="platform_stock p-100 text_white bg_stock text_stock"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <h1>
              PLATFORM <span>FEATURES</span>
            </h1>
            <p>
              Stock n Ship mainly enables stores, suppliers, and the admin side
              to access particular portals where they can navigate and get the
              insights they need.
            </p>
            <p>
              TekRevol had a clear-cut product development strategy where we
              focused on including features such as the onboarding process,
              dynamic dashboard, active navigations, and handle tasks related to
              the inventory, orders, payment gateway, and API configuration.
            </p>
            <p>
              Once TekRevol fulfilled the requirements, we arranged features
              according to different stakeholders – stores, suppliers, and the
              admin.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Platformstock;
